import { render, staticRenderFns } from "./DataTableColumnToggle.vue?vue&type=template&id=4df15d0b&"
import script from "./DataTableColumnToggle.vue?vue&type=script&lang=js&"
export * from "./DataTableColumnToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports